import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
  const decryptedData = CryptoJS.AES.decrypt(localStorage.getItem("token"), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);
  return decryptedData;
};

export const getSubscriptionPlanAction = async (currentPage, searchValue, pageSize, status, byUser) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  let apiUrl = `/api/plan?page=${currentPage}&searchValue=${searchValue}&pageSize=${pageSize}&status=${status}`;
  if (byUser) {
    apiUrl += `&byUser=${byUser}`;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createSubscriptionAction = async (data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .post("/api/plan/", data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

export const editSubscriptionAction = async (data, id) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/plan/${id}`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getSubscriptionByIdAction = async (id) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/plan/${id}`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteSubscriptionByIdAction = async (id) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/plan/plan-delete/${id}`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateSubscriptionStatusAction = async (id, status) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const data = {
    isActive: status,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/plan/update-plan-status/${id}`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteMultipleSubscriptionByIdAction = async (data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/plan/delete-multiple-plan`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
